import tools from '../tools/tools.js';
export default function(){
	const html = document.querySelector('html');
	const me = this;
	const simpleAll = document.querySelectorAll('.glowz-menu-simple');
	const burgerAll = document.querySelectorAll('.glowz-burger');
	const isRtl = !!document.querySelector('html[dir=rtl]');

	this.state = 1;
	this.scrollY = 0;
	this.setState = function(state){
		if(state === 1 && this.state !== 1){
			this.state = 1;
			html.classList.remove('glowz-state2');
			html.classList.add('glowz-state1');
		}else if(state === 2 && this.state !== 2){
			this.state = 2;
			html.classList.remove('glowz-state1');
			html.classList.add('glowz-state2');
		}
	}
	const isEmptyA = function(el){
		const href = el.getAttribute('href')
		return (href === '#' || href === '' || !href);
	}
	const activate = function(a){
		let el;
		if(a.classList.contains('glowz-section-link')){
			el = a.parentElement.parentElement
		}else if(a.classList.contains('glowz-grid-item-link')){
			el = a.parentElement
		}else{
			el = a
		}
		el.classList.add('glowz-active');
	}
	const setActiveLinks = function(){
		document.querySelectorAll('.glowz-active').forEach(function(el){
			el.classList.remove('glowz-active');
		});
		const noHashLocation = document.location.href.split('#')[0]
		const isCurrent = (el)=>{
			return !isEmptyA(el) && (
				(!document.location.hash && el.href === document.location.href) ||
				(!el.hash && document.location.hash && el.href === noHashLocation)
			)
		}
		document.querySelectorAll('.glowz-menu-simple li>a, .glowz-menu li>a').forEach(function(el){
			if(isCurrent(el)){
				tools.parents(el, 'li').forEach(function(par){
					activate(par.querySelector(':scope>a'));
				});
			}
		});
		document.querySelectorAll('.wp-site-blocks a, #glowz-primary a, #glowz-footer a').forEach(function(el){
			if(isCurrent(el)){
				activate(el);
			}
		});
	}
	setActiveLinks();
	window.addEventListener("hashchange", setActiveLinks, false);

	//Begin For Greenshift Slider
	if(!document.location.hash){
		const firstGSHashed = document.querySelector('.swiper-slide[data-hash]')
		if(firstGSHashed && firstGSHashed.dataset.hash){
			document.querySelectorAll("a[href='#"+firstGSHashed.dataset.hash+"']").forEach(function(el){
				activate(el)
			});
		}
	}
	//End For Greenshift Slider

	let fixLayouts;
	const fixLayoutsInit = ()=>{
		fixLayouts = new Set();
		const fixedsAll = document.querySelectorAll('.glowz-fixed, .glowz-fixed-medium, .glowz-fixed-small');
		if(fixedsAll.length > 0){
			let contentContainer = document.querySelector('.glowz-theme .wp-site-blocks, .block-editor-block-preview__content-iframe .is-root-container');
			if(!contentContainer){
				return;
			}
			let fixLTop = 0;
			let fixLBottom = 0;
			let fixLLeft = 0;
			let fixLRight = 0;
			let prevFixL = false;
			const contentContainerRec = contentContainer.getBoundingClientRect();
			const defTop = contentContainerRec.top  + window.scrollY;
			const defLeft = contentContainerRec.left  + window.scrollX;
			const defRight = document.body.clientWidth - contentContainerRec.right + window.scrollX;
			const defBottom =  0;
			fixedsAll.forEach((fixed)=>{
				const fixL = {
					fixed,
					type: undefined,
					rec: undefined,
					prev: prevFixL,
					next: false,
					width: fixed.style.width,
					maxWidth: fixed.style.maxWidth
				};
				if(prevFixL){
					prevFixL.next = fixL;
				}
				fixL.calcTop = (def)=>{
					if(fixL.type === 'top'){
						const r = fixL.rec.bottom + window.scrollY;
						const myRes = r > def ? r : def;
						return fixL.prev ? fixL.prev.calcTop(myRes) : myRes;
					}else{
						return fixL.prev ? fixL.prev.calcTop(def) : def;
					}
				}
				fixL.calcBottom = (def)=>{
					if(fixL.type === 'bottom'){
						const r = fixL.rec.bottom - fixL.rec.top + window.scrollY;
						const myRes = r > def ? r : def;
						return fixL.prev ? fixL.prev.calcBottom(myRes) : myRes;
					}else{
						return fixL.prev ? fixL.prev.calcBottom(def) : def;
					}
				}
				fixL.calcLeft = (def)=>{
					if(fixL.type === 'left' || fixL.type === 'leftH'){
						const r = fixL.rec.right + window.scrollX;
						const myRes = r > def ? r : def;
						return fixL.prev ? fixL.prev.calcLeft(myRes) : myRes;
					}else{
						return fixL.prev ? fixL.prev.calcLeft(def) : def;
					}
				}
				fixL.calcRight = (def)=>{
					if(fixL.type === 'right' || fixL.type === 'rightH'){
						const r = document.body.clientWidth - fixL.rec.left + window.scrollX;
						const myRes = r > def ? r : def;
						return fixL.prev ? fixL.prev.calcRight(myRes) : myRes;
					}else{
						return fixL.prev ? fixL.prev.calcRight(def) : def;
					}
				}
				fixL.layout = ()=>{
					const fType = getComputedStyle(fixed).getPropertyValue('--glowz-fixed');
					if(fType == 1){
						fixL.type = 'top';
					}else if(fType == 2){
						fixL.type = 'right';
					}else if(fType == 3){
						fixL.type = 'bottom';
					}else if(fType == 4){
						fixL.type = 'left';
					}else if(fType == 5){
						fixL.type = 'leftH';
					}else if(fType == 6){
						fixL.type = 'rightH';
					}else{
						fixL.type = false;
					}
					fixed.style.removeProperty('transformOrigin');
					fixed.style.removeProperty('transform');
					fixed.style.removeProperty('top');
					fixed.style.removeProperty('right');
					fixed.style.removeProperty('bottom');
					fixed.style.removeProperty('left');
					fixed.style.width = fixL.width;
					fixed.style.maxWidth = fixL.maxWidth;
					if(fixL.type){
						const top = fixL.prev ? fixL.prev.calcTop(defTop) : defTop;
						const bottom = fixL.prev ? fixL.prev.calcBottom(defBottom) : defBottom;
						const left = fixL.prev ? fixL.prev.calcLeft(defLeft) : defLeft;
						const right = fixL.prev ? fixL.prev.calcRight(defRight) : defRight;
						if(fixL.type === 'top' || fixL.type === 'bottom'){
							fixed.style.left = left + 'px';
							fixed.style.right = right + 'px';
							if(fixL.type === 'top'){
								fixed.style.top = top + 'px';
							}else{
								fixed.style.bottom = bottom + 'px';
							}
							fixed.style.width = 'auto';
						}else if(fixL.type === 'left' || fixL.type === 'right'){
							const h = window.innerHeight - top - bottom
							fixed.style.top = (top + h) + 'px';
							fixed.style.width = h + 'px';
							if(fixL.type === 'left'){
								fixed.style.transformOrigin = 'left top';
								fixed.style.left = left + 'px';
								fixed.style.transform = 'rotateZ(-90deg)';
							}else{
								fixed.style.transformOrigin = 'right top';
								fixed.style.right = right + 'px';
								fixed.style.transform = 'rotateZ(90deg)';
							}
						}else if(fixL.type === 'leftH' || fixL.type === 'rightH'){
							fixed.style.top = top + 'px';
							fixed.style.bottom = bottom + 'px';
							if(fixL.type === 'leftH'){
								fixed.style.left = left + 'px';
							}else{
								fixed.style.right = right + 'px';
							}
						}
						fixed.style.setProperty('max-width', 'none', 'important');
					}
					fixL.rec = fixed.getBoundingClientRect();
				}
				fixLayouts.add(fixL);
				prevFixL = fixL;
			});
		}
	}
	const fixLayoutsLayout = ()=>{
		fixLayouts.forEach((fixL)=>{
			fixL.layout();
		})
	}
	const fixLayoutsReady = ()=>{
		fixLayouts.forEach((fixL)=>{
			fixL.fixed.classList.add('glowz-ready');
		})
	}
	fixLayoutsInit();
	const fixLayoutsObserver = new MutationObserver(function(mutations) {
			fixLayoutsInit();
			fixLayoutsLayout();
			fixLayoutsReady();
	});
	fixLayoutsObserver.observe(document, {childList: true, subtree: true});
	window.addEventListener("resize", fixLayoutsLayout);
	fixLayoutsLayout();
	fixLayoutsReady();
	burgerAll.forEach((burger)=>{
		const fixedsStore = new Set();
		const pane = burger.querySelector('.glowz-ext-menu-pane');
		const burgButton = burger.querySelector('.glowz-burger-button');
		const nav = pane ? pane.querySelector('.glowz-nav') : false;
		const menu = nav ? nav.querySelector('.glowz-menu') : false;
		const allLi = menu ? menu.querySelectorAll('li') : [];
		const allLiA = menu ? menu.querySelectorAll('li a') : [];
		let impact = false;
		let impactParent = false;
		const noImpact = function(){
			if(pane && impact){
				pane.classList.remove('glowz-impacted');
				impact.classList.remove('glowz-impact');
				impact = false;
				if(impactParent){
					impactParent.classList.remove('glowz-impact-parent');
					impactParent = false;
				}
			}
		}
		const impactUl = function(ul){
			if(pane && !ul.classList.contains('glowz-impact')){
				if(ul.classList.contains('sub-menu')){
					pane.classList.add('glowz-impacted');
					if(impact){
						impact.classList.remove('glowz-impact');
					}
					impact = ul;
					impact.classList.add('glowz-impact');
					if(impactParent){
						impactParent.classList.remove('glowz-impact-parent');
					}
					impactParent = ul.parentNode.parentNode;
					impactParent.classList.add('glowz-impact-parent');
				}else{
					noImpact();
				}
			}
		}
		const burgClick = function(){
			setTimeout(function(){
				if(burgDoClose){
					burgDoClose = false;
					noImpact();
					if(allLi.length > 0){
						allLi.forEach(function(el){el.classList.remove('glowz-item-open');});
					}
				}
			}, 1000);
			if(document.body.classList.contains('glowz-primary-menu-open')){
				burgDoClose = true;
				document.body.classList.remove('glowz-primary-menu-open');
				document.body.classList.remove('glowz-primary-menu-opened');
			}else{
				burgDoClose = false;
				document.body.classList.add('glowz-primary-menu-open');
				setTimeout(function(){
					if(document.body.classList.contains('glowz-primary-menu-open')){
						document.body.classList.add('glowz-primary-menu-opened');
					}
				}, 1000)
			}
		}
		const close = function(){
			if(document.body.classList.contains('glowz-primary-menu-open')){
				burgClick();
			}
		}
		const closeIfOnlyHashLink = (a)=>{
			if(a.href && window.location.href.split('#')[0] === a.href.split('#')[0]){
				close()
			}
		}
		const navigate = (a)=>{
			window.location.href = a.href;
			setActiveLinks();
		}
		document.querySelectorAll('.wp-block-site-title a, .wp-block-site-logo a').forEach( function(el){ el.addEventListener('click', function(){
			close();
		}, tools.passiveListener) } );
		let burgDoClose = false;
		if(burgButton){
			burgButton.addEventListener('click', burgClick, tools.passiveListener);
		}
		if(allLi.length > 0){
			allLi.forEach(function(li){
				const layerLi = Array.prototype.filter.call(li.parentNode.children, function(ch){return ch.matches('li')});
				const sub = li.querySelector(':scope>ul');
				const a = li.querySelector(':scope>a');
				const closeLayer = function(){
					layerLi.forEach(function(itemLi){
						itemLi.classList.remove('glowz-item-open');
						itemLi.querySelectorAll('li').forEach(function(subli){
							subli.classList.remove('glowz-item-open');
						})
					});
				}
				const openLi = function(){
					const topMargin = nav.getBoundingClientRect().top;
					closeLayer();
					li.classList.add('glowz-item-open');
					if(sub){
						impactUl(sub);
						const rect = li.getBoundingClientRect();
						if(!isRtl){
							if((document.documentElement.clientWidth - rect.right) < sub.offsetWidth && rect.left > sub.offsetWidth){
								sub.classList.remove('glowz-submenu-right');
								sub.classList.add('glowz-submenu-left');
							}else{
								sub.classList.remove('glowz-submenu-left');
								sub.classList.add('glowz-submenu-right');
							}
						}else{
							if((document.documentElement.clientWidth - rect.left) < sub.offsetWidth && (document.documentElement.clientWidth - rect.right) > sub.offsetWidth){
								sub.classList.remove('glowz-submenu-left');
								sub.classList.add('glowz-submenu-right');
							}else{
								sub.classList.remove('glowz-submenu-right');
								sub.classList.add('glowz-submenu-left');
							}
						}
						if((document.documentElement.clientHeight - rect.top) < (sub.offsetHeight + topMargin)){
							if(rect.bottom > (sub.offsetHeight + topMargin)){
								sub.style.top = 'auto';
								sub.style.bottom = '0px';
							}else{
								sub.style.top = 'auto';
								sub.style.bottom = (rect.bottom - sub.offsetHeight - topMargin) + 'px';
							}
						}else{
							sub.style.top = '0px';
							sub.style.bottom = 'auto';
						}
					}else{
						const currentUl = li.parentNode;
						if(!currentUl.classList.contains('glowz-impact')){
							impactUl(currentUl);
						}
					}
				}
				if(sub){
					a.addEventListener('click', function(e){
						e.preventDefault();
					});
					a.addEventListener('pointerdown', function(e){
						if(!li.classList.contains('glowz-item-open')){
							openLi();
						}else{
							const href = a.getAttribute('href')
							if(isEmptyA(a)){
								impactUl(li.parentNode);
								closeLayer();
								hover = true;
							}else{
								closeIfOnlyHashLink(a)
								navigate(a);
							}
						}
					}, tools.passiveListener);
				}else{
					a.addEventListener('click', function(e){
						closeIfOnlyHashLink(a)
					}, tools.passiveListener);
				}

				let hover = false;
				a.addEventListener('mouseover', function(e){
					if(!hover) {
						if(sub){
							openLi();
						}else{
							impactUl(li.parentNode);
							closeLayer();
						}
					}
					hover = true;
				}, tools.passiveListener);
				a.addEventListener('mouseleave', function(e){
					hover = false;
				}, tools.passiveListener);
			});
			if(pane){
				pane.addEventListener('click', function(e){
					const isLink = function(){
						let res = false;
						allLiA.forEach(function(a){
							if( a === e.target || a.contains(e.target) ){
								res = true;
							}
						});
						return res;
					}
					if( !isLink() ){
						noImpact();
						allLi.forEach(function(li){
							li.classList.remove('glowz-item-open');
						});
					}
				}, tools.passiveListener);
			}
		}
	});
	simpleAll.forEach((simple)=>{
		let openCount = 0;
		const allLi = simple.querySelectorAll('li');
		allLi.forEach(function(li){
			const sub = li.querySelector(':scope>ul');
			const a = li.querySelector(':scope>a');
			if(sub){
				let opened = false;
				const outHandler = function(e){
					if(opened && !li.contains(e.target)){
						close();
					}
				}
				const open = function(){
					openCount++;
					if(openCount === 1){
						html.classList.add('glowz-simple-menu-opened');
					}
					li.classList.add('glowz-item-open');
					opened = true;
					document.addEventListener('pointerdown', outHandler, tools.passiveListener);
				}
				const close = function(){
					openCount--;
					if(openCount === 0){
						html.classList.remove('glowz-simple-menu-opened');
					}
					li.classList.remove('glowz-item-open');
					opened = false;
					document.removeEventListener('pointerdown', outHandler);
				}
				a.addEventListener('pointerdown', function(e){
					if(opened){
						close();
						if(!isEmptyA(a)){
							navigate(a);
						}
					}else{
						open();
					}
				}, tools.passiveListener);
				a.addEventListener('click', function(e){
					e.preventDefault();
				});
				const mOver = function(e){
					if(!opened){
						open();
					}
				}
				a.addEventListener('mouseover', mOver, tools.passiveListener);
				a.addEventListener('focus', mOver);
				const mLeave = function(e){
					if(opened){
						close();
					}
				}
				li.addEventListener('mouseleave', mLeave, tools.passiveListener);
			}
			
		});
	} )
	/*let secondPartY;
	let isHasSecondPart;
	const resizeB = () => {
		secondPartY = false;
		isHasSecondPart = false;
		//const secondEls = document.querySelectorAll('.entry-content>.glowz-def-height-full:first-child ~ *, .entry-content>:has(.glowz-def-height-full):first-child ~ *, footer')
		const secondEls = document.querySelectorAll('.entry-content ~ footer, .glowz-def-height-full ~ footer, :has(.entry-content) ~ footer, :has(.glowz-def-height-full) ~ footer')
		for (const el of secondEls) {
			const elPos = el.getBoundingClientRect().top + window.scrollY
			const y = elPos - window.innerHeight;
			if(isHasSecondPart){
				if(y < secondPartY){
					secondPartY = y
				}
			}else{
				secondPartY = y
				isHasSecondPart = true;
			}
		}
	}*/

	let secondPartY;
	let isHasSecondPart = false;
	const resizeB = () => {
		const secondPart = document.querySelector('footer')
		isHasSecondPart = secondPart ? true : false;
		if(isHasSecondPart){
			const elPos = secondPart.getBoundingClientRect().top + window.scrollY
			secondPartY = elPos - window.innerHeight;
		}
	}
	const resizeObserverB = new ResizeObserver(resizeB);
	resizeObserverB.observe(document.body);
	resizeB();

	/*if(isHasSecondPart && secondPartY < 0){
		const content = document.querySelector('.glowz-theme .wp-site-blocks')
		if(content){
			content.style.minHeight = window.innerHeight + secondPart.offsetHeight + 'px';
			resizeB();
		}
	}*/
	let isSecondPart = false;
	const scroll = ()=>{
		if(me.scrollY !== window.scrollY){
			me.scrollY = window.scrollY;
			if(me.scrollY > 0){
				me.setState(2);
			}else{
				me.setState(1);
			}
		}
		if(isHasSecondPart && window.scrollY > 0 && window.scrollY > secondPartY){
			if(!isSecondPart){
				isSecondPart = true;
				html.classList.add('glowz-second-part');
			}
		}else{
			if(isSecondPart){
				isSecondPart = false;
				html.classList.remove('glowz-second-part');
			}
		}
	}
	document.addEventListener('scroll', scroll, tools.passiveListener);
	scroll()
}
